import type {
	CustomInterventionCommandModel,
	FullGoalDefinitionViewModel,
	FullInterventionDefinitionViewModel,
	InterventionDefinitionViewModel,
	PredefinedInterventionCommandModel
} from '@generated';
import { convertClientValuesToServerValues } from '~/libraries/forms/values';
import { isFullInterventionDefinition } from '~/libraries/interventions/util';
import type { FormRegistryValues } from '~/shared/forms/FormRegistryContext';
import type { FormValues } from '~/shared/forms/types';

function getBaseValues(id: string, values: FormValues) {
	return {
		id,
		notes: values?.notes,
		projectedStartDate: values.projectedStartDate,
		projectedEndDate: values.projectedEndDate,
		homeHealthAideInterventionFrequencyTypeId: values?.homeHealthAideInterventionFrequencyTypeId,
		homeHealthAideInterventionFrequencyTypeOther: values?.homeHealthAideInterventionFrequencyTypeOther,
		assignedDisciplineIds: values.assignedDisciplineIds
	};
}

export function transformPredefinedInterventionForSave(
	formValues: FormRegistryValues,
	interventionId: string,
	interventionDefinition: FullInterventionDefinitionViewModel | InterventionDefinitionViewModel
): PredefinedInterventionCommandModel {
	const baseValues = {
		...getBaseValues(interventionId, formValues),
		interventionDefinitionId: interventionDefinition.id
	};
	if (!isFullInterventionDefinition(interventionDefinition)) {
		return baseValues;
	}
	return {
		...baseValues,
		interventionDefinitionValues:
			interventionDefinition.definitionFormFields && formValues
				? convertClientValuesToServerValues(formValues, interventionDefinition.definitionFormFields)
				: undefined
	};
}

export function transformCustomInterventionForSave(formRegisteryValues: FormRegistryValues, interventionId: string): CustomInterventionCommandModel {
	const values = formRegisteryValues[interventionId];
	return {
		...getBaseValues(interventionId, values),
		interventionTypeId: values.interventionTypeId,
		subject: values.subject,
		definitionText: values.definitionText,
		canBePerformedByPatient: values.canBePerformedByPatient,
		canBePerformedByCaregiver: values.canBePerformedByCaregiver,
		assignedDisciplineId: values.assignedDisciplineId
	};
}

export function transformGoalForSave(formRegisteryValues: FormRegistryValues, goalId: string, goalDefinition: FullGoalDefinitionViewModel) {
	return {
		goalId: goalId,
		goalDefinitionId: goalDefinition.id,
		goalDefinitionValues: goalDefinition.definitionFormFields
			? convertClientValuesToServerValues(formRegisteryValues[goalDefinition.id], goalDefinition.definitionFormFields)
			: undefined
	};
}
